import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import Select from 'react-select';
import api from '../services/api';
import authService from '../services/authService';
import productService from '../services/productService';

const DealerStockPage = () => {
  const [dealers, setDealers] = useState([]);
  const [products, setProducts] = useState([]);
  const [dealerStocks, setDealerStocks] = useState([]);
  
  const [selectedDealer, setSelectedDealer] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState('');
  const [expandedRow, setExpandedRow] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const users = await authService.getAllUsers();
        // Admin harici tüm kullanıcıları listele (Bayi, Personel vb.)
        setDealers(users.filter(u => u.role !== 'admin'));
        
        const prods = await productService.getAll();
        setProducts(prods);

        const stocks = await api.get('/dealers/stock');
        setDealerStocks(stocks.data);
      } catch (error) {
        toast.error('Veriler yüklenirken hata oluştu.');
      }
    };
    loadData();
  }, []);

  const toggleRow = (id) => setExpandedRow(expandedRow === id ? null : id);

  const handleAssignStock = async (e) => {
    e.preventDefault();
    if (!selectedDealer || !selectedProduct || !quantity) {
      toast.warning('Lütfen tüm alanları doldurun.');
      return;
    }

    try {
      await api.post('/dealers/stock', {
        user_id: selectedDealer.value,
        product_id: selectedProduct.value,
        quantity: parseInt(quantity)
      });
      toast.success('Stok güncellendi.');
      
      // Listeyi yenile
      const stocks = await api.get('/dealers/stock');
      setDealerStocks(stocks.data);
      setQuantity('');
    } catch (error) {
      toast.error('Stok atama başarısız.');
    }
  };

  return (
    <div className="container-fluid mt-4">
      <h2 className="mb-4">Bayi Stok Yönetimi</h2>

      <div className="card shadow-sm mb-4">
        <div className="card-header bg-white">
          <h5 className="mb-0">Stok Ekle / Güncelle</h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleAssignStock}>
            <div className="row">
              <div className="col-md-4 mb-3">
                <label className="form-label">Bayi Seç</label>
                <Select 
                  options={dealers.map(d => ({ value: d.id, label: `${d.full_name} (${d.role})` }))}
                  value={selectedDealer}
                  onChange={setSelectedDealer}
                  placeholder="Bayi Seçiniz..."
                />
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">Ürün Seç</label>
                <Select 
                  options={products.map(p => ({ value: p.id, label: p.name }))}
                  value={selectedProduct}
                  onChange={setSelectedProduct}
                  placeholder="Ürün Seçiniz..."
                />
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label">Miktar</label>
                <input type="number" className="form-control" value={quantity} onChange={(e) => setQuantity(e.target.value)} min="0" />
              </div>
              <div className="col-md-2 mb-3 d-flex align-items-end">
                <button type="submit" className="btn btn-primary w-100">Kaydet</button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className="card shadow-sm">
        <div className="card-header bg-white">
          <h5 className="mb-0">Bayi Stok Durumu</h5>
        </div>
        <div className="card-body">
          <div className="table-responsive d-none d-md-block">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Bayi Adı</th>
                  <th>Ürün</th>
                  <th>Stok Miktarı</th>
                  <th>Son Güncelleme</th>
                </tr>
              </thead>
              <tbody>
                {dealerStocks.map((stock) => (
                  <tr key={stock.id}>
                    <td>{stock.dealer_name}</td>
                    <td>{stock.product_name}</td>
                    <td className="fw-bold">{stock.stock_quantity}</td>
                    <td>{new Date(stock.updated_at).toLocaleDateString('tr-TR')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobil Görünüm */}
          <div className="d-md-none">
            {dealerStocks.map((stock) => (
              <div className="card mb-3 shadow-sm" key={stock.id}>
                <div className="card-body" onClick={() => toggleRow(stock.id)} style={{ cursor: 'pointer' }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 className="mb-0 fw-bold">{stock.dealer_name}</h6>
                      <small className="text-muted">{stock.product_name}</small>
                    </div>
                    <div className="text-end">
                      <div className="fw-bold">{stock.stock_quantity}</div>
                      <small className="text-muted">{expandedRow === stock.id ? <FaChevronUp /> : <FaChevronDown />}</small>
                    </div>
                  </div>

                  {expandedRow === stock.id && (
                    <div className="mt-3 border-top pt-3">
                      <p className="mb-1"><strong>Son Güncelleme:</strong> {new Date(stock.updated_at).toLocaleDateString('tr-TR')}</p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DealerStockPage;
